import { selectionControlSizes } from '../selectionControl/theme'
import { checkboxColors } from './consts'

const baseStyle = {
  control: {
    color: checkboxColors.unchecked,
    hoverColor: checkboxColors.hover,
    pressedColor: checkboxColors.pressed,
  },
  // `alignItems` is computed in checkbox.tsx (centered vs. top-aligned depending on content) — not set here,
  // since a static value would silently override that logic when spread onto CheckboxBase.
  container: {},
}

const defaultProps = {
  size: 'md',
}

const parts = ['container', 'control', 'label']

// Sizes/gaps shared with Radio — see `selectionControl/theme.ts`. `lg` kept as a deprecated alias
// for `md` for backwards compatibility.
const sizes = selectionControlSizes

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
